import { Stack, Button, Text } from "prism-react";

import { useProjectSettingsContext } from "./SettingsProvider";

export const SettingsModalHeader = () => {
  const { setVisibility } = useProjectSettingsContext();

  return (
    <Stack
      css={{
        justifyContent: "space-between",
      }}
      horizontal
    >
      <Text color="neutral-fg-base" size="sm" weight="medium">
        Settings
      </Text>
      <Button icon="close" onClick={() => setVisibility(false)} />
    </Stack>
  );
};
